import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxBorder, Color, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

type InfoItem = {
  label: string;
  value: string | React.ReactNode;
};
export interface SubscriptionSolicitationSuccessDetailsProps {
  infoItems: InfoItem[];
}

export const SubscriptionSolicitationSuccessDetails: React.FC<
  SubscriptionSolicitationSuccessDetailsProps
> = ({ infoItems }) => {
  const renderInfo = (info: InfoItem) => {
    const isValueString = typeof info.value === 'string';

    return (
      <HStack justifyContent="space-between" space={Spacing['inline.quarck']}>
        <UI.Text>{info.label}</UI.Text>
        {isValueString ? (
          <UI.Text maxW={{ base: '200px', sm: '2/3' }} variant="semibold" textAlign="right">
            {info.value}
          </UI.Text>
        ) : (
          info.value
        )}
      </HStack>
    );
  };

  return (
    <UI.Shadow level={1} borderRadius={BoxBorder.heavy}>
      <VStack p={Spacing['inset.sm']} space={Spacing['stack.xxxs']}>
        <HStack
          borderRadius={BoxBorder.heavy}
          p={Spacing['inset.nano']}
          space={Spacing['inline.quarck']}
          bg={Utils.ColorToken.WithOpacity('neutral.lightest', 0.15)}
          alignItems="center">
          <UI.Icon name="Check" size="md" color={Color['feedback.success.default']} />
          <VStack maxW="90%">
            <UI.Text variant="semibold">Solicitação enviada com sucesso!</UI.Text>
          </VStack>
        </HStack>

        <VStack
          borderRadius={BoxBorder.heavy}
          px={Spacing['inline.xxs']}
          py={Spacing['stack.xxxs']}
          space={Spacing['stack.nano']}
          bg={Utils.ColorToken.WithOpacity('brand.tertiary.lightest', 0.3)}>
          <UI.Text variant="semibold">Detalhes da solicitação</UI.Text>
          {infoItems.map((item) => (
            <Stack key={item.label} w="full">
              {renderInfo(item)}
            </Stack>
          ))}
        </VStack>
      </VStack>
    </UI.Shadow>
  );
};
